// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-entry {
  display: grid;
  grid-template-columns: 80px 1fr 140px;
  gap: 1rem;
  padding: 1rem 1.5rem;
  align-items: center;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f5f9;
}

.leaderboard-entry:hover {
  background: #f8fafc;
}

.leaderboard-entry.even {
  background: #fefefe;
}

.leaderboard-entry.odd {
  background: #fcfcfc;
}

.leaderboard-entry.current-user {
  background: linear-gradient(90deg, #e6fffa 0%, #b2f5ea 100%) !important;
  border-left: 4px solid #38b2ac;
  font-weight: 500;
}

.leaderboard-entry.current-user:hover {
  background: linear-gradient(90deg, #d6f5f2 0%, #9ae6d9 100%) !important;
}

/* Rank column */
.rank {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-weight: bold;
}

.rank-display {
  font-size: 1.2rem;
}

.rank-gold .rank-display {
  color: #d69e2e;
  font-size: 1.5rem;
}

.rank-silver .rank-display {
  color: #718096;
  font-size: 1.4rem;
}

.rank-bronze .rank-display {
  color: #c05621;
  font-size: 1.3rem;
}

.rank-normal .rank-display {
  color: #4a5568;
}

.tied-indicator {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 0.7rem;
  color: #a0aec0;
  background: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
}

/* User column */
.user-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0; /* Allow text truncation */
}

.user-id {
  font-weight: 500;
  color: #2d3748;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.current-user-badge {
  background: #38b2ac;
  color: white;
  padding: 0.125rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  align-self: flex-start;
}

/* Tasks solved column */
.tasks-solved {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.tasks-number {
  font-size: 1.25rem;
  font-weight: bold;
  color: #2d3748;
}

.tasks-label {
  font-size: 0.75rem;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}


/* Responsive design */
@media (max-width: 768px) {
  .leaderboard-entry {
    grid-template-columns: 60px 1fr 100px;
    gap: 0.5rem;
    padding: 1rem;
  }


  .user-avatar {
    width: 32px;
    height: 32px;
    font-size: 0.8rem;
  }

  .rank-display {
    font-size: 1rem;
  }

  .rank-gold .rank-display,
  .rank-silver .rank-display,
  .rank-bronze .rank-display {
    font-size: 1.2rem;
  }

  .tasks-number {
    font-size: 1.1rem;
  }

  .user-details {
    gap: 0.125rem;
  }

  .current-user-badge {
    font-size: 0.7rem;
    padding: 0.1rem 0.4rem;
  }
}

@media (max-width: 480px) {
  .leaderboard-entry {
    grid-template-columns: 50px 1fr 80px;
    padding: 0.75rem;
  }

  .user-avatar {
    width: 28px;
    height: 28px;
    font-size: 0.75rem;
  }

  .user-id {
    font-size: 0.9rem;
  }

  .tasks-solved {
    gap: 0.125rem;
  }

  .tasks-number {
    font-size: 1rem;
  }

  .tasks-label {
    font-size: 0.7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/leaderboard/LeaderboardEntry.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uEAAuE;AACzE;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,WAAW;IACX,aAAa;EACf;;;EAGA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,oCAAoC;IACpC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".leaderboard-entry {\n  display: grid;\n  grid-template-columns: 80px 1fr 140px;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  align-items: center;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.leaderboard-entry:hover {\n  background: #f8fafc;\n}\n\n.leaderboard-entry.even {\n  background: #fefefe;\n}\n\n.leaderboard-entry.odd {\n  background: #fcfcfc;\n}\n\n.leaderboard-entry.current-user {\n  background: linear-gradient(90deg, #e6fffa 0%, #b2f5ea 100%) !important;\n  border-left: 4px solid #38b2ac;\n  font-weight: 500;\n}\n\n.leaderboard-entry.current-user:hover {\n  background: linear-gradient(90deg, #d6f5f2 0%, #9ae6d9 100%) !important;\n}\n\n/* Rank column */\n.rank {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  font-weight: bold;\n}\n\n.rank-display {\n  font-size: 1.2rem;\n}\n\n.rank-gold .rank-display {\n  color: #d69e2e;\n  font-size: 1.5rem;\n}\n\n.rank-silver .rank-display {\n  color: #718096;\n  font-size: 1.4rem;\n}\n\n.rank-bronze .rank-display {\n  color: #c05621;\n  font-size: 1.3rem;\n}\n\n.rank-normal .rank-display {\n  color: #4a5568;\n}\n\n.tied-indicator {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  font-size: 0.7rem;\n  color: #a0aec0;\n  background: white;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #e2e8f0;\n}\n\n/* User column */\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 0.9rem;\n  flex-shrink: 0;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-width: 0; /* Allow text truncation */\n}\n\n.user-id {\n  font-weight: 500;\n  color: #2d3748;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.current-user-badge {\n  background: #38b2ac;\n  color: white;\n  padding: 0.125rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  align-self: flex-start;\n}\n\n/* Tasks solved column */\n.tasks-solved {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.tasks-number {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: #2d3748;\n}\n\n.tasks-label {\n  font-size: 0.75rem;\n  color: #718096;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .leaderboard-entry {\n    grid-template-columns: 60px 1fr 100px;\n    gap: 0.5rem;\n    padding: 1rem;\n  }\n\n\n  .user-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 0.8rem;\n  }\n\n  .rank-display {\n    font-size: 1rem;\n  }\n\n  .rank-gold .rank-display,\n  .rank-silver .rank-display,\n  .rank-bronze .rank-display {\n    font-size: 1.2rem;\n  }\n\n  .tasks-number {\n    font-size: 1.1rem;\n  }\n\n  .user-details {\n    gap: 0.125rem;\n  }\n\n  .current-user-badge {\n    font-size: 0.7rem;\n    padding: 0.1rem 0.4rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .leaderboard-entry {\n    grid-template-columns: 50px 1fr 80px;\n    padding: 0.75rem;\n  }\n\n  .user-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 0.75rem;\n  }\n\n  .user-id {\n    font-size: 0.9rem;\n  }\n\n  .tasks-solved {\n    gap: 0.125rem;\n  }\n\n  .tasks-number {\n    font-size: 1rem;\n  }\n\n  .tasks-label {\n    font-size: 0.7rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
